import React from 'react';

import { PAGE_TYPES } from '@dashboard/enums/page-types';

import AdminChargesList from '@dashboard/admin/components/AdminChargesList';

const Bookings = () => (
  <AdminChargesList
    pageType={PAGE_TYPES.EVENT}
    titleHeader="Event"
    getTitle={charge => charge.page?.title}
    testFilterLabel="Include test bookings"
    emptyStateTitle="No bookings found"
    viewLabel="View booking"
    viewPath="/bookings"
    supportsComplimentary
  />
);

export default Bookings;
